var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(_vm.viewComponent,{key:_vm.metric.name,tag:"component",attrs:{"metric":_vm.metric,"account-id":_vm.accountId,"facebook-page-id":_vm.facebookPageId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }